import React from "react";
export default function Income({ children }) {
  return <div className="income">{children}</div>;
}
